"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toTypeString = void 0;

var _is = require("./is");

const toTypeString = source => {
  if (source === null) {
    return 'null';
  }

  const type = typeof source;

  switch (type) {
    case 'bigint':
      return `BigInt(${source})`;

    case 'boolean':
      return `Boolean(${source})`;

    case 'function':
      return 'Function';

    case 'number':
      return `Number(${source})`;

    case 'string':
      return `String(${source})`;

    case 'symbol':
      return source.toString();

    case 'undefined':
      return 'undefined';

    default:
      {
        var _constructor;

        if ((0, _is.isPromiseLike)(source)) {
          return 'Promise';
        } else if ((0, _is.isDate)(source)) {
          return `Date(${source.toISOString()})`;
        } else if ((0, _is.isError)(source)) {
          return `${source.constructor.name}(${source.message})`;
        } else if ((0, _is.isMap)(source)) {
          return `Map(${source.size})`;
        } else if ((0, _is.isSet)(source)) {
          return `Set(${source.size})`;
        } else if ((0, _is.isArray)(source)) {
          return `Array(${source.length})`;
        } else if ((0, _is.isRegExp)(source)) {
          return `RegExp(${source.source})`;
        } else if ((0, _is.isString)((_constructor = source.constructor) === null || _constructor === void 0 ? void 0 : _constructor.name)) {
          if (source.toString === Object.prototype.toString) {
            return `${source.constructor.name}({ ${Object.keys(source).sort().join(', ')} })`;
          } else {
            return source.toString();
          }
        } else if (source.toString === Object.prototype.toString) {
          return `${source.constructor.name}({ ${Object.keys(source).sort().join(', ')} })`;
        } else {
          return source.toString();
        }
      }
  }
};

exports.toTypeString = toTypeString;